import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ClientTaxBinderDetailPage } from '@/features/tax-binders/ClientTaxBinderDetailPage';

// Search param schema for documents sub-tabs
const documentsSearchSchema = z.object({
  view: z.enum(['client-provided', 'firm-delivered']).optional().catch('client-provided'),
});

export type DocumentsSearch = z.infer<typeof documentsSearchSchema>;

export const Route = createFileRoute('/tax-binders/$binderId/documents')({
  validateSearch: documentsSearchSchema,
  component: () => <ClientTaxBinderDetailPage />,
});
